<!-- Overlay con desenfoque para el detalle -->
<div class="fixed inset-0 z-[120] bg-[#1a2e35]/30 backdrop-blur-sm flex items-center justify-center p-0 md:p-10 transition-all">
  
  <!-- Contenedor Modal: Full screen en mobile, tarjeta centrada en desktop -->
  <div class="w-full h-full md:max-w-5xl md:max-h-[90vh] bg-white md:rounded-2xl flex flex-col overflow-hidden shadow-2xl animate-fade-in relative">
    
    @if (loading) {
      <div class="flex-1 flex items-center justify-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-metro-blue"></div>
      </div>
    } @else {
      <!-- Header con Cruz -->
      <div class="pt-safe bg-white sticky top-0 z-10 border-b border-gray-50">
        <div class="pt-6 pb-4">
          <div class="flex items-center justify-center relative px-4 md:px-6 h-10">
            <h3 class="font-semibold text-lg text-[#1a2e35] break-words max-w-[80%] text-center">{{ wine.name }}</h3>
            <button (click)="closed.emit()" class="absolute right-4 md:right-6 inset-y-0 flex items-center justify-center w-10 md:w-12 text-gray-300 hover:text-gray-900 transition-all -translate-y-1">
              <span class="text-3xl leading-none">&times;</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Scrollable Content -->
      <div class="flex-1 overflow-y-auto px-6 md:px-10 pb-32">
        <div class="max-w-4xl mx-auto">
          
          <!-- Image Area -->
          <div class="w-full h-[25vh] md:h-[35vh] flex justify-center items-center mb-10 mt-6 relative">
            <img [src]="imageUrl || 'assets/images/no-image.png'" class="max-w-full max-h-full object-contain rounded-lg" alt="wine">
          </div>

          <!-- Title & Price -->
          <div class="mb-6">
            <h2 class="text-lg text-metro-blue-secondary font-bold uppercase tracking-wide mb-1">{{ wine.name }}</h2>
            <p class="text-lg font-semibold text-gray-900">{{ formatCurrency(wine.price) }}</p>
          </div>

          <!-- Attributes Grid -->
          <div class="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
            <div class="flex flex-col items-start border-b border-gray-100 pb-2">
              <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Winery' | abpLocalization }}</span>
              <span class="text-sm font-medium">{{ wine.wineryName || '-' }}</span>
            </div>
            <div class="flex flex-col items-start border-b border-gray-100 pb-2">
              <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Type' | abpLocalization }}</span>
              <span class="text-sm font-medium">{{ wine.type || '-' }}</span>
            </div>
            <div class="flex flex-col items-start border-b border-gray-100 pb-2">
              <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Varietal' | abpLocalization }}</span>
              <span class="text-sm font-medium">{{ wine.varietal || '-' }}</span>
            </div>
            @if (wine.harvest) {
              <div class="flex flex-col items-start border-b border-gray-100 pb-2">
                <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Harvest' | abpLocalization }}</span>
                <span class="text-sm font-medium">{{ wine.harvest }}</span>
              </div>
            }
            <div class="flex flex-col items-start border-b border-gray-100 pb-2">
              <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Country' | abpLocalization}}</span>
              <div class="flex items-center gap-1">
                @if (wine.wineryCountry) {
                <img [src]="'assets/images/flags/' + getCountryCode(wine.wineryCountry) + '.svg'" alt="{{ wine.wineryCountry }}"
                  class="w-4 h-4 rounded-full object-cover">
                }
                <span class="text-sm font-medium">{{ wine.wineryCountry || '-' }}</span>
              </div>
            </div>
            <div class="flex flex-col items-start border-b border-gray-100 pb-2">
              <span class="text-xs text-metro-blue font-semibold mb-1">{{'::Region' | abpLocalization }}</span>
              <span class="text-sm font-medium">{{ wine.wineryRegion || '-' }}</span>
            </div>
          </div>

          <!-- Description -->
          <div class="flex flex-col items-start mb-10">
            <span class="text-xs text-metro-blue font-semibold mb-2 uppercase tracking-widest">{{ '::Description' | abpLocalization }}</span>
            <p class="text-sm font-medium text-gray-500 leading-relaxed">{{ wine.description || ('::NoDescriptionAvailable' | abpLocalization) }}</p>
          </div>
        </div>
      </div>

      <!-- Footer Action (Fixed inside modal) -->
      <div class="absolute bottom-0 left-0 right-0 p-3 sm:p-6 md:p-8 bg-white border-t border-gray-100 flex flex-wrap md:flex-nowrap items-center justify-center gap-2 sm:gap-4 z-20 md:rounded-b-2xl">
        
        <!-- Quantity Selector -->
        <div class="flex items-center justify-center gap-1 sm:gap-2 flex-shrink-0">
          <button class="px-2 sm:px-4 py-2 rounded-md bg-metro-blue text-metro-secondary font-bold text-lg sm:text-xl"
            (click)="decreaseQuantity()" [disabled]="quantity <= 1">-</button>

          <input type="number" [value]="quantity" (input)="onQuantityChange($event)" min="1"
            class="w-10 sm:w-16 text-center focus:outline-none no-spinners font-bold text-lg sm:text-xl">

          <button class="px-2 sm:px-4 py-2 rounded-md bg-metro-blue text-metro-secondary font-bold text-lg sm:text-xl"
            (click)="increaseQuantity()">+</button>
        </div>

        <!-- Add Button -->
        <div class="flex-1 min-w-[150px] md:max-w-md">
          <app-metro-button
            variant="primary"
            [fullWidth]="true"
            [text]="'::AddToCart' | abpLocalization"
            [loading]="adding"
            (clicked)="addToCart()">
          </app-metro-button>
        </div>
      </div>
    }
  </div>
</div>
